// src/admin/routes/AdminRoutes.jsx
import React from "react";
import { Routes, Route } from "react-router-dom";
import AdminLayout from "../components/AdminLayout";
import Dashboard from "../pages/Dashboard";
import Users from "../pages/Users";
import CreateUser from "../pages/CreateUser";
import UserProgressSummary from "../pages/UserProgressSummary";
import Courses from "../pages/Courses";
import CourseDetail from "../pages/CourseDetail";
import BulkUpload from "../pages/BulkUpload";
import Cohorts from "../pages/Cohorts";
import CohortDetail from "../pages/CohortDetail";
import CreateCohort from "../pages/CreateCohort";
import UserMaintenance from "../pages/UserMaintenance";
import Waitlist from "../pages/Waitlist";
import Analytics from "../pages/Analytics";
import AccountabilityBookings from "../pages/AccountabilityBookings";
import PaymentSettings from "../pages/PaymentSettings";
import ConsultationBookings from "../pages/ConsultationBookings";

const AdminRoutes = () => {
  return (
    <AdminLayout>
      <Routes>
        <Route path="/" element={<Dashboard />} />
        <Route path="/users" element={<Users />} />
        <Route path="/users/create" element={<CreateUser />} />
        <Route
          path="/users/:userId/progress-summary"
          element={<UserProgressSummary />}
        />
        <Route path="/courses" element={<Courses />} />
        <Route path="/courses/:courseId" element={<CourseDetail />} />
        <Route path="/courses/:courseId/bulk-upload" element={<BulkUpload />} />
        <Route path="cohorts" element={<Cohorts />} />
        <Route path="cohorts/create" element={<CreateCohort />} />
        <Route path="cohorts/:cohortId" element={<CohortDetail />} />
        <Route path="/maintenance" element={<UserMaintenance />} />
        <Route path="/waitlist" element={<Waitlist />} />
        <Route path="/analytics" element={<Analytics />} />
        <Route path="/payments" element={<PaymentSettings />} />
        <Route path="/accountability-bookings" element={<AccountabilityBookings />} />
        <Route path="/consultation-bookings" element={<ConsultationBookings />} />
      </Routes>
    </AdminLayout>
  );
};

export default AdminRoutes;
